import type { SVGProps } from 'react';

/**
 * Custom "Excluded Products" icon (a shopping bag / tote).
 * Mirrors the exact artwork from the Figma sidebar design.
 * Stroke inherits the current text color so it matches the other sidebar items.
 */
export function ExcludedProductsIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M12.8352 1.72333L9.91523 0.75C9.91523 1.45724 9.63428 2.13552 9.13418 2.63562C8.63408 3.13572 7.95581 3.41667 7.24856 3.41667C6.54132 3.41667 5.86304 3.13572 5.36294 2.63562C4.86285 2.13552 4.5819 1.45724 4.5819 0.75L1.6619 1.72333C1.36015 1.82386 1.10428 2.02894 0.940465 2.30156C0.77665 2.57418 0.715681 2.89638 0.768562 3.21L1.15523 5.52333C1.18061 5.67994 1.26102 5.82236 1.38199 5.92501C1.50296 6.02765 1.65658 6.08379 1.81523 6.08333H3.24856V12.75C3.24856 13.4833 3.84856 14.0833 4.5819 14.0833H9.91523C10.2689 14.0833 10.608 13.9429 10.858 13.6928C11.1081 13.4428 11.2486 13.1036 11.2486 12.75V6.08333H12.6819C12.8405 6.08379 12.9942 6.02765 13.1151 5.92501C13.2361 5.82236 13.3165 5.67994 13.3419 5.52333L13.7286 3.21C13.7814 2.89638 13.7205 2.57418 13.5567 2.30156C13.3928 2.02894 13.137 1.82386 12.8352 1.72333Z" />
    </svg>
  );
}
